import angular from 'angular';

angular
  .module('cloudX')
  .controller('EmployeeInsightDialogCtrl', [
    '$element',
    '$sce',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'employeeId',
    employeeInsightDialogCtrl,
  ]);

function employeeInsightDialogCtrl($element, $sce, $http, appUrls, flySvc, close, employeeId) {
  var vm = this;

  vm.startDate = null;
  vm.endDate = null;
  vm.generating = false;
  vm.reportHtml = null;
  vm.trustedReportHtml = null;
  vm.startDateOpen = false;
  vm.endDateOpen = false;

  vm.generate = function() {
    if (!vm.startDate || !vm.endDate || vm.generating) return;

    vm.generating = true;
    $http
      .post(`${appUrls.api}/api/EmployeeInsight/generate`, {
        employeeId: employeeId,
        startDate: vm.startDate,
        endDate: vm.endDate,
      })
      .then(function(response) {
        vm.reportHtml = response.data.reportHtml;
        vm.trustedReportHtml = $sce.trustAsHtml(response.data.reportHtml);
      })
      .catch(function(error) {
        flySvc.error(error.data && error.data.code ? error.data.code : 'GenericError');
      })
      .finally(function() {
        vm.generating = false;
      });
  };

  vm.reset = function() {
    vm.reportHtml = null;
    vm.trustedReportHtml = null;
  };

  vm.close = function() {
    close(null, 500);
  };
}
